/* ----------------------- List ----------------------- */
export const set = config => ({ type: 'CONFIGURATION_UPDATED', newConfig: config });
